import * as yup from "yup";

export const LoginFormSchema = yup.object({
  email: yup.string().required("Please fill in your registered email").email("Please fill in a valid email"),
  password: yup.string().required("Please fill in your password"),
});

export type LoginFormSchema = yup.InferType<typeof LoginFormSchema>;
